module.exports = __webpack_public_path__ + "img/speech_6.39fb12b7.jpeg";